/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Enable_PreviewInputs */



/**
* | output |
* | --- |
* | "Enable ADR Preview" |
*
* @param {Options_Adr_Enable_PreviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_enable_preview = /** @type {((inputs?: Options_Adr_Enable_PreviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Enable_PreviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer l'aperçu ADR")
	if (locale === "de") return /** @type {LocalizedString} */ ("ADR-Vorschau aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita anteprima ADR")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить предварительный просмотр ADR")
	if (locale === "es") return /** @type {LocalizedString} */ ("Habilitar la vista previa de ADR")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用 ADR 预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADRプレビューを有効にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एडीआर पूर्वावलोकन सक्षम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar a pré-visualização de ADR")
	return /** @type {LocalizedString} */ ("Enable ADR Preview")
});